export default {
  namespaced: true,

  state: {
    isPlaying: false,
    currentTime: 250,
    currentSpeed: 2000,
    visible: false,
    geoTimeLine: null,
    geoTimeScale: null,
    demUrl: '/terrains',
    // demUrl:'https://globallayer.deepearth.cn/terrains',
    dem: false,
  },

  mutations: {
    setIsPlaying(state, isPlaying) {
      state.isPlaying = isPlaying;
    },

    setCurrentTime(state, currentTime) {
      state.currentTime = currentTime;
    },

    setVisible(state, visible) {
      state.visible = visible;
    },

    setGeoTimeLine(state, geoTimeline) {
      state.geoTimeLine = geoTimeline;
    },

    setGeoTimeScale(state, geoTimeScale) {
      state.geoTimeScale = geoTimeScale;
    },

    setDem(state, dem) {
      state.dem = dem;
    },

    setCurrentSpeed(state, currentSpeed) {
      state.currentSpeed = parseInt(currentSpeed);
    },

    reset(state) {
      state.isPlaying = false;
      state.currentTime = 300;
      state.visible = false;
      state.geoTimeline = null;
      state.geoTimeScale = null;
      state.dem = false;
    }
  }
}